import { FIELD_BIND_TYPE_ENUM } from '@constants'
import { CommandParametersType } from '@types'

export const trim = (value?: string | null) => (value ?? '').trim()

export const getTypeIdUpper = (item?: CommandParametersType | null) =>
  String(item?.type?.id ?? '').toUpperCase()

export const isConfiguredParameter = (item?: CommandParametersType | null) => {
  const typeCode = getTypeIdUpper(item)
  if (!typeCode) return false

  const hasValue = Boolean(trim(item?.value))
  const hasPath = (item?.pathArray?.length ?? 0) > 0

  return typeCode === FIELD_BIND_TYPE_ENUM.FIELD ? hasPath || hasValue : hasValue
}

export const isStartedParameter = (item?: CommandParametersType | null) =>
  Boolean(item?.type || trim(item?.value) || (item?.pathArray?.length ?? 0) > 0 || item?.objectCode)
